"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchController = void 0;
const gs = require("@ivanlog/gs");
const AppControllerBase_1 = require("./AppControllerBase");
const models_1 = require("../api/classes/models");
const QueryFilterTypeEnum_1 = require("../enums/QueryFilterTypeEnum");
const QuerySortTypeEnum_1 = require("../enums/QuerySortTypeEnum");
class SearchController extends AppControllerBase_1.AppControllerBase {
    constructor(app) {
        super(app);
        this._inStock = true;
        this._sortType = QuerySortTypeEnum_1.QuerySortTypeEnum.UpPrice;
        this._categoryId = 0;
        this._onRefreshQueryToken = new gs.EventGSToken();
        this.onRefreshQuery = new gs.EventGS(this._onRefreshQueryToken);
    }
    initialize() {
        const sortType = localStorage.getItem(SearchController.SortStorageName);
        if (!sortType)
            return;
        this._sortType = parseInt(sortType);
    }
    get filterInStock() { return this._inStock; }
    set filterInStock(value) { this._inStock = value; }
    get sortType() { return this._sortType; }
    set sortType(value) { this._sortType = value; localStorage.setItem(SearchController.SortStorageName, value + ""); }
    get filterCategory() { return this._categoryId; }
    set filterCategory(categoryId) { this._categoryId = categoryId; }
    refreshQuery() {
        this._onRefreshQueryToken.invoke();
    }
    getFilters(skipCategory = false) {
        const result = [];
        if (this.filterInStock) {
            const filter = new models_1.QueryFilter();
            filter.filterTypeId = QueryFilterTypeEnum_1.QueryFilterTypeEnum.FILTER_IN_STOCK;
            result.push(filter);
        }
        if (!skipCategory && this._categoryId > 0) {
            const filter = new models_1.QueryFilter();
            filter.filterTypeId = QueryFilterTypeEnum_1.QueryFilterTypeEnum.FILTER_CATEGORY;
            filter.values = [this._categoryId + ""];
            result.push(filter);
        }
        return result;
    }
    getFilterString(skipCategory = false) {
        const filters = this.getFilters(skipCategory);
        const s = [];
        for (const f of filters) {
            s.push(f.filterTypeId + "|" + f.values);
        }
        return s.join("|");
    }
}
exports.SearchController = SearchController;
SearchController.SortStorageName = "searchSort";
//# sourceMappingURL=SearchController.js.map